import { getLeadingZeroDate } from "../dateTime";

export const areISODatesOnTheSameDay = (dateA: string, dateB: string) =>
    getLeadingZeroDate(dateA) === getLeadingZeroDate(dateB)
;